import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.view.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthCallbackComponent implements OnInit {
  message: string;
  constructor(
    private _router: Router
  ) {
  }

  ngOnInit(): void {
    // MSAL handles the redirect response in initializeMsal() before bootstrap;
    // the login route then forwards signed-in users (same routing as under ADAL).
    this._router.navigate(['']);
  }
}
